import type { Content } from '@prismicio/client';
import type { Simplify } from '../../../../../../prismicio-types';

import { OptimizedPrismicImage } from '@/components';
import { HeroCardRange } from '../../../components';

import styles from './personalLoansHeroCards.module.scss';

interface PersonalLoansHeroCardsProps {
  data: Simplify<Content.HeroSlicePersonalLoansPrimary>;
  isVisible: boolean;
}

export const PersonalLoansHeroCards = ({
  data,
  isVisible,
}: PersonalLoansHeroCardsProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.cards}>
      <div className={`${styles.offer} ${isVisibleStyles}`}>
        <ul className={styles.values}>
          {data.offer_items.map((item) => (
            <li key={item.description} className={styles.item}>
              <span>{item.description}</span>
              <span>{item.value}</span>
            </li>
          ))}
        </ul>
        <div className={`${styles.reverse} ${isVisibleStyles}`}>
          <div className={styles.rect} />
          <div className={styles.circle} />
        </div>
      </div>
      <div className={`${styles.photo} ${isVisibleStyles}`}>
        <div className={styles.image_wrapper}>
          <OptimizedPrismicImage
            field={data.client_photo}
            className={styles.image}
          />
        </div>
      </div>
      <div className={`${styles.amount} ${isVisibleStyles}`}>
        <div className={styles.heading_wrapper}>
          <span>{data.amount_heading}</span>
          <span>{data.amound_value}</span>
        </div>
        <HeroCardRange cursor="default" />
      </div>
    </article>
  );
};
